import React, { createContext, useState, useEffect, Children } from "react";
import { useNavigate } from "react-router-dom";
import { dbKeys, path, tableName } from "../constant";
import SupabaseService from "../utils/supabaseClient";
import { useLocation, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { useTheme } from "@mui/material/styles";
import { useMediaQuery } from "@mui/material";
import Loading from "../components/loading/Loading";
import WalkInSnackBar from "../shared/snackbar/WalkInSnackBar";
export const FunctionContext = createContext();
function FunctionProvider({ children }) {
  const [loading, setloading] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  let page = queryParams.get("page");
  const limit = queryParams.get("limit");
  const job_location = queryParams.get(dbKeys.job_location);
  const id = queryParams.get("id");
  const job_title = queryParams.get(dbKeys.job_title);
  const job_employment_type = queryParams.get(dbKeys.job_employment_type);
  const [query, setQuery] = useState({
    walkInTitle: job_title,
    walkInLocation: job_location,
    employmentType: job_employment_type,
  });
  const [walkinlist, setwalkinlist] = useState();
  const theme = useTheme();
  const customBreakpoints = {
    isMobile: useMediaQuery(theme.breakpoints.down("sm")),
    isDeviceDown: useMediaQuery(theme.breakpoints.down("md")),
  };
  const [next, setnext] = useState(0);
  const [openSnack, setOpenSnack] = useState({
    open: false,
    type: "success",
    message: "",
  });
  const handleSnackClose = () => {
    setOpenSnack({ ...openSnack, open: false });
  };
  // Extract query parameters
  function findElement(data, key, value) {

    if (Array.isArray(data)) {
    
        return data.find(item => item[key] === value).title;
    } else if (typeof data === 'object' && data !== null) {
        return Object.keys(data).find(k => data[k] === value) || null;
    }
    return null;
}
  const setdata = async () => {
    setloading(false);
    const temp = {
      walkInTitle: job_title,
      walkInLocation: job_location,
      employmentType: job_employment_type,
    };
    setQuery({ ...temp });
    const data = await SupabaseService.getData(
      tableName.postWalkin,
      page ? page : 1,
      5,
      temp,
      id
    );
    
    setwalkinlist(data);
    setloading(true);
  };
  useEffect(()=>{
    changeLanguage("English")
  },[])
  useEffect(() => {
    setdata();
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [page, job_location, job_title, job_employment_type, id,location.pathname]);
  const onChangequery = (e) => {
    const temp = query;
    const key = e.target.name;
    const value = e.target.value;
    temp[key] = value;
    setQuery({ ...temp });
  };
  const searchSubmit = (query) => {
    navigate(path.searchPage(1, 5, query));
  };
  const generatePageNumber = (totalItems, limit, offset = 4) => {
    const totalPages = Math.ceil(totalItems / limit); // Calculate total pages
    const pages = [];
    for (let i = 1; i <= totalPages; i++) {
    
      pages.push(
        Array.from(
          { length: totalPages !== 4 ? totalPages : offset },
          (_, index) => i + index
        ).slice(0, offset)
      );
    }
   
    return { pages: pages[page - 1], totalPages: totalPages };
  };
  const { t, i18n } = useTranslation();
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng); // Change the language dynamically
  };

  return (
    <FunctionContext.Provider
      value={{
        navigate,
        searchSubmit,
        onChangequery,
        query,
        queryParams,
        page,
        walkinlist,
        limit,
        setQuery,
        generatePageNumber,
        customBreakpoints,
        openSnack,
        setOpenSnack,
        t: t,
        changeLanguage: changeLanguage,
        findElement
      }}
    >
      {loading ? children : <Loading></Loading>}
      <WalkInSnackBar state={openSnack} handleClose={handleSnackClose} />
    </FunctionContext.Provider>
  );
}

export default FunctionProvider;
